import { ChevronDown, ChevronRight } from 'react-feather';
import BillingDetails from '../clients/BillingDetails';

const OrderPaymentHistorySection = ({
	sections,
	toggleSection,
	orderDetails,
}) => {
	return (
		<div className="installation-permits">
			<div className="instalation-permits-block">
				<div
					className="title-block"
					onClick={() => toggleSection('invoice')}
				>
					<h2 className="title-h2">Payment History</h2>
					<button type="button">
						{sections.invoice ? (
							<ChevronDown size={24} />
						) : (
							<ChevronRight size={24} />
						)}
					</button>
				</div>
				{sections.invoice && (
					<>
						<div className="content-box mb-10">
							<div className="total-to-pay w-full">
								<p className="total-to-pay-title text-right w-full">
									Total to pay: <strong>${orderDetails?.total}</strong>
								</p>
							</div>
						</div>
						<div className="content-box">
							<BillingDetails order={orderDetails} />
						</div>
					</>
				)}
			</div>
		</div>
	);
};

export default OrderPaymentHistorySection;
